import { useCallback } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import type { CustomTableHeaderProps, TableFilterValueType } from '@interxfi/design-system/components/table';
import { ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields, ExcJpmamV1NetOrderStatus } from '@interxfi/types';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { JpmamVendorTabRail } from '../../../../../../../../../../features/vendor/jpmam/jpmam-vendor-tab-rail';
import { JpmamNetOrdersTable } from '../../../../../../../../../../features/vendor/jpmam/net-order/jpmam-net-orders-table';
import { JpmamPendingOrderBanner } from '../../../../../../../../../../features/vendor/jpmam/net-order/jpmam-pending-order-banner';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/net-order/_net-order/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingVendorJpmam,
      label: 'Net Orders',
      order: 1,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingVendorJpmam>,
  head: () => getPageHead('JPMAM Net Orders'),
  component: JpmamNetOrderList,
});

function TableHeader({ filter, filterProps }: CustomTableHeaderProps<ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields>) {
  const handleApplyPendingFilter = useCallback(() => {
    filterProps?.onFilterChange({
      ...(filterProps.values || ({} as Record<ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields, TableFilterValueType<any>>)),
      [ExcJpmamV1NetOrderQueryServiceNetOrderListFilterableFields.Status]: { multiple: [ExcJpmamV1NetOrderStatus.Pending] },
    });
  }, [filterProps?.onFilterChange, filterProps?.values]);

  return (
    <VerticalStack gap={7}>
      <JpmamVendorTabRail
        actions={
          <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
            {filter}
          </HorizontalStack>
        }
      />

      <JpmamPendingOrderBanner handleApplyPendingFilter={handleApplyPendingFilter} />
    </VerticalStack>
  );
}

function JpmamNetOrderList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <JpmamNetOrdersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
